const COMMENTS = [
  {
    name: '星空下的追剧人',
    date: '3天前',
    content: '天美麻花星空影视真的太强了！4K蓝光画质比我之前用的所有平台都清晰，而且真的不缓冲，晚上高峰期也能秒开，强烈推荐给身边所有朋友。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20modern%20user%20avatar%20portrait%20illustration%20of%20a%20young%20person%20with%20warm%20tones%2C%20minimal%20clean%20design%2C%20soft%20lighting%2C%20circular%20composition%2C%20simple%20background&width=80&height=80&seq=avatar-user-01&orientation=squarish',
  },
  {
    name: '剧集收藏家',
    date: '5天前',
    content: '在这里找到了好几部找了很久的老剧，资源真的太全了！国产剧、韩剧、美剧都有，更新还特别快，每天都有新内容上线，已经离不开这个平台了。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20modern%20user%20avatar%20portrait%20illustration%20of%20a%20young%20woman%20with%20warm%20amber%20tones%2C%20minimal%20clean%20design%2C%20soft%20lighting%2C%20circular%20composition%2C%20simple%20background&width=80&height=80&seq=avatar-user-02&orientation=squarish',
  },
  {
    name: '大屏观影爱好者',
    date: '1周前',
    content: '用天美麻花星空影视TV版在65寸电视上看蓝光电影，体验简直绝了！画质细腻，色彩饱满，配合家庭音响就像在私人影院一样，而且是完全免费的。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20modern%20user%20avatar%20portrait%20illustration%20of%20a%20middle%20aged%20man%20with%20warm%20neutral%20tones%2C%20minimal%20clean%20design%2C%20soft%20lighting%2C%20circular%20composition%2C%20simple%20background&width=80&height=80&seq=avatar-user-03&orientation=squarish',
  },
  {
    name: '动漫追番人',
    date: '2周前',
    content: '作为一个老二次元，天美麻花星空影视的动漫资源库让我惊喜！新番同步更新很快，老番也有完整合集，画质都是高清起步，看《鬼灭之刃》蓝光版太爽了。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20modern%20user%20avatar%20portrait%20illustration%20of%20a%20young%20person%20with%20cool%20vibrant%20tones%2C%20minimal%20clean%20design%2C%20soft%20lighting%2C%20circular%20composition%2C%20simple%20background&width=80&height=80&seq=avatar-user-04&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-50">
            用户热评
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            来自真实用户的观看体验分享
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto">
          {COMMENTS.map((comment, idx) => (
            <div
              key={idx}
              className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-300/15"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200 border border-background-300/20">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.currentTarget as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div>
                  <div className="text-sm font-heading font-bold text-foreground-100">
                    {comment.name}
                  </div>
                  <div className="text-xs text-foreground-600">{comment.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}